































































import { Component, Prop, Emit, Vue } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';

@Component({
  components: {
    ValidationProvider,
  },
})
export default class FlTranslatableTextarea extends Vue {
  @Prop({ default: '' }) private value!: any;
  @Prop({
    default: function () {
      return {};
    },
  })
  private rules?: object;
  @Prop({
    default: function () {
      return {};
    },
  })
  private rules2?: object;
  @Prop({ default: 'text' }) private type!: string;
  @Prop({ default: '' }) private label!: string;
  @Prop({ default: '' }) private label2?: string;
  @Prop({ default: '' }) private sublabel?: string;
  @Prop({ default: '' }) private fieldId!: string;
  @Prop({ default: () => [] }) private errors?: string[];
  @Prop({ default: 'aggressive' }) private mode: string;
  @Prop({ default: 'ja' }) private fromLanguage: string;
  @Prop({ default: 'en' }) private toLanguage: string;
  // @Prop({ default: () => ({}) }) private textCount!: object;
  @Emit('input')
  input(newValue: any) {
    return newValue;
  }
  get inputValue() {
    return this.value;
  }
  set inputValue(newValue: any) {
    this.input(newValue);
  }
  get fromInputValue() {
    return this.value[this.fromLanguage][this.fieldId];
  }
  set fromInputValue(value: string) {
    this.value[this.fromLanguage][this.fieldId] = value;
  }
  get toInputValue() {
    return this.value[this.toLanguage][this.fieldId];
  }
  set toInputValue(value: string) {
    this.value[this.toLanguage][this.fieldId] = value;
  }
  get translationFromVid() {
    return 'translation_to_' + this.fieldId;
  }
  get translationToVid() {
    return 'translation_from_' + this.fieldId;
  }
  get textCount() {
    if (
      this.value &&
      Object.keys(this.value).includes(this.fromLanguage) &&
      Object.keys(this.value).includes(this.toLanguage) &&
      Object.keys(this.value[this.fromLanguage]).includes(this.fieldId) &&
      Object.keys(this.value[this.toLanguage]).includes(this.fieldId) &&
      this.value[this.fromLanguage][this.fieldId] !== null &&
      this.value[this.toLanguage][this.fieldId] !== null
    ) {
      const fromTextCount = this.value[this.fromLanguage][this.fieldId].length;
      const toTextCount = this.value[this.toLanguage][this.fieldId].length;
      return {
        from: fromTextCount,
        to: toTextCount,
      };
    }
    return {
      from: 0,
      to: 0,
    };
  }

  getFromTranslationLanguage() {
    if (this.fromLanguage === 'ja') {
      return this.$t('components.pulldownModal.language.ja');
    } else if (this.fromLanguage === 'en') {
      return this.$t('components.pulldownModal.language.en');
    }
  }

  getToTranslationLanguage() {
    if (this.toLanguage === 'ja') {
      return this.$t('components.pulldownModal.language.ja');
    } else if (this.toLanguage === 'en') {
      return this.$t('components.pulldownModal.language.en');
    }
  }

  translate() {
    const keys = Object.keys(this.value);
    const requestParams = {
      text: this.value[this.fromLanguage][this.fieldId],
      translate_from: this.fromLanguage,
      translate_to: this.toLanguage,
    };
    let parent = this.value[this.toLanguage];
    this.axios({
      url: '/translation',
      method: 'POST',
      data: requestParams,
    })
      .then((result) => {
        if (result.status === 200) {
          this.$set(parent, this.fieldId, result.data.text);
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  }
}
